import {
  Attachment,
  Avatar,
  MessageStatus,
  MessageText,
  MessageTimestamp,
  useMessageContext,
} from 'stream-chat-react';

import { useConversationContext } from './conversationProvider';

export const CustomMessage = () => {
  const { isMyMessage, groupedByUser, message } = useMessageContext();
  const { store, user } = useConversationContext();
  const messageClasses = isMyMessage()
    ? 'str-chat__message str-chat__message--me str-chat__message-simple str-chat__message-simple--me'
    : 'str-chat__message str-chat__message-simple';

  return (
    <div className={messageClasses}>
      <MessageStatus />
      {isMyMessage() ? (
        <Avatar name={user.first_initial} />
      ) : (
        <Avatar image={store.photo} name={store.name} />
      )}
      <div className="str-chat__message-inner">
        <MessageText />
        {message.attachments && (
          <Attachment attachments={message.attachments} />
        )}
        {!groupedByUser && (
          <div className="str-chat__message-data str-chat__message-simple-data">
            {!isMyMessage() && (
              <span className="str-chat__message-simple-name">
                {store.name}
              </span>
            )}
            <MessageTimestamp
              calendar
              customClass="str-chat__message-simple-timestamp"
            />
          </div>
        )}
      </div>
    </div>
  );
};
